<section class="grid grid-cols-2 gap-2 py-2 my-3 items-center even:bg-gray-500/25 dark:even:bg-gray-500/15">
	{@render children?.()}
</section>

<script>
const { children } = $props()
</script>
